export default __webpack_public_path__ + "static/media/blackringcitadelwing3.8e07dfb1.jpg";